import api from '@/apis/di/accountParallelRuleDetailAPI';
import Crud from '@/stores/crudBaseCache';
var crud = new Crud('accountParallelRuleDetail', api);
const state = {
  ...crud.state,
  _config: {
    table: 'di_account_parallel_rule_detail',
    field: {
      key: 'rule_detail_id',
      foreignKey: 'account_parallel_rule_id',
      sign: 'sign',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Lấy chia tiết dữ liệu rule hạch toán đồng thời theo id
   * @param {*} context
   * @returns
   * HTHIEP 08.07.2022
   */
  async getDataById(context, id) {
    const items = await api.getDataById(id);
    if (!items) {
      return;
    }
    return items;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
